export default "__VITE_ASSET__CVrpDy9b__"